<div class="relative flex flex-col justify-between rounded-2xl border border-gray-200 bg-white p-5 shadow-sm h-44">
  <!-- Upper-right corner layout (warning icon + transfer icon) -->
  <div class="absolute top-3 right-3 flex items-center space-x-1.5">
    <!-- Warning icon (upper-right) -->
    <div class="relative group" *ngIf="isBelowThreshold">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd" />
      </svg>
      <div
        class="pointer-events-none absolute right-0 top-6 z-10 hidden w-max rounded-md bg-gray-800 px-2 py-1 text-xs text-white group-hover:block">
        Balance below threshold
      </div>
    </div>

    <!-- Transfer icon button -->
    <button *ngIf="isWalletsManager" (click)="onTransferClick($event)"
      class="rounded-lg p-1.5 text-gray-400 hover:text-blue-600 hover:bg-gray-100 transition focus:outline-none"
      title="Create internal transfer">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
      </svg>
    </button>
  </div>

  <!-- Wallet info (upper-left) -->
  <div>
    <p class="text-sm font-semibold text-gray-800 leading-tight">
      {{ wallet.config.name }}
    </p>
    <div class="mt-0.5 flex items-center gap-1">
      <p class="text-xs text-gray-400 font-mono" title="{{ wallet.config.address }}">
        {{ shortAddress }}
      </p>
      <button (click)="copyAddress()" class="text-gray-400 hover:text-gray-600 transition" title="Copy address">
        <svg *ngIf="!copied" xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-4 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
        <svg *ngIf="copied" xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 text-green-500" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Balance + Refresh (lower row) -->
  <div class="flex items-end justify-between mt-4">
    <!-- Refresh button (lower-left) -->
    <button (click)="refresh()" [disabled]="wallet.loading"
      class="flex items-center gap-1 rounded-md border border-gray-200 px-2 py-1 text-xs text-gray-500 hover:bg-gray-50 disabled:opacity-40 transition"
      title="Refresh balance">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" [class.animate-spin]="wallet.loading" fill="none"
        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
    </button>

    <!-- Balance (lower-right) -->
    <div class="text-right">
      <ng-container *ngIf="wallet.loading">
        <div class="h-4 w-20 animate-pulse rounded bg-gray-200"></div>
      </ng-container>
      <ng-container *ngIf="!wallet.loading && wallet.error">
        <span class="text-xs text-red-500" [title]="wallet.error">Error</span>
      </ng-container>
      <ng-container *ngIf="!wallet.loading && !wallet.error && wallet.balance !== null">
        <div>
          <span class="text-xl font-bold" [class.text-amber-500]="isBelowThreshold"
            [class.text-gray-800]="!isBelowThreshold">
            {{ wallet.balance | number: "1.2-2" }}
          </span>
          <span class="ml-1 text-xs text-gray-400 font-medium">USDC</span>
        </div>
        <div *ngIf="wallet.config.provider === 'PRIVY'">
          <span class="text-xl font-bold text-gray-800">
            {{ (wallet.eurcBalance ?? 0) | number: "1.2-2" }}
          </span>
          <span class="ml-1 text-xs text-gray-400 font-medium">EURC</span>
        </div>
      </ng-container>
      <ng-container *ngIf="!wallet.loading && !wallet.error && wallet.balance === null">
        <span class="text-sm text-gray-400">—</span>
      </ng-container>
    </div>
  </div>
</div>